export class ScheduledListLang {

    variables  = null;

    constructor(lang) {

        this.variables = {
            courseCode: lang.academy[168],                        
            catalogCode: lang.academy[1],                        
            courseTitle: lang.academy[3],                        
            description: lang.academy[22],                        
            courseCategory: lang.academy[4],                        
            durationHours: lang.academy[5],                        
            coursesCatalog: lang.academy[1],                        
            startDate: lang.academy[40],                        
            endDate: lang.academy[41],                        
            teacher: lang.academy[45],                        
            customer: lang.academy[43],                        
            noofattendies: lang.academy[241],                        
            status: lang.academy[42],                        
            action: lang.academy[7],
            close: lang.general[17],
            save: lang.general[0],
            place_of_performance: lang.academy[274],
            actuator_body: lang.academy[275],
            main_teacher: lang.academy[276],
            title: lang.academy[28],
            module_number: lang.academy[27],
            teacher_title: lang.academy[45],
            execution_dates: lang.academy[236],
            scheduled_courses: lang.general[57],

            select_status: lang.academy[101],
            programmed: lang.academy[102],
            active: lang.academy[103],
            finished: lang.academy[104],
            suspended: lang.academy[105],
            undefined: lang.academy[106],
        }

    } 

    lang() {
        return this.variables;
    }

}

export class ScheduledViewListLang {

    variables  = null;

    constructor(lang) {

        this.variables = {
            courseCode: lang.academy[168],                        
            catalogCode: lang.academy[1],                        
            courseTitle: lang.academy[3],                        
            description: lang.academy[22],                        
            courseCategory: lang.academy[4],                        
            durationHours: lang.academy[5],                        
            coursesCatalog: lang.academy[1],                        
            startDate: lang.academy[40],                        
            endDate: lang.academy[41],                        
            teacher: lang.academy[45],                        
            customer: lang.academy[43],                        
            noofattendies: lang.academy[241],                        
            status: lang.academy[42],                        
            action: lang.academy[7],    
            code: lang.academy[250],    
            businessName: lang.academy[251],    
            address: lang.academy[132],    
            zipCode: lang.academy[133],    
            city: lang.academy[124],    
            province: lang.academy[217],    
            taxCode: lang.academy[131],    
            fiscalCode: lang.academy[130],    
            macroSector: lang.academy[252],    
            telephone: lang.academy[122],    
            email: lang.academy[123],    
            contract: lang.academy[136],    
            addAttendees: lang.academy[253],    

        }

    }

    lang() {
        return this.variables;
    }

}

